import { ExpandAllButton as BaseExpandAllButton } from '@sbv-clients/ui-shared';

export function ExpandAllButton({
  useContextFn,
}: {
  useContextFn: () => {
    setExpanded: (value: boolean) => void;
    expanded: boolean;
  };
}) {
  const { expanded, setExpanded } = useContextFn();
  return (
    <BaseExpandAllButton
      sx={{ minWidth: '110px' }}
      expanded={expanded}
      toggle={setExpanded}
    />
  );
}
